"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PenSlash: function() {
        return PenSlash;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const PenSlash = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.8787 1.70718C19.0502 0.535599 20.9497 0.535595 22.1213 1.70717L22.2929 1.87874C23.4645 3.05031 23.4645 4.9498 22.2929 6.12138L14.9142 13.5001L22.7071 21.293C23.0976 21.6835 23.0976 22.3166 22.7071 22.7072C22.3166 23.0977 21.6834 23.0977 21.2929 22.7072L12.7929 14.2072L9.79293 11.2072L1.29289 2.70717C0.902369 2.31664 0.902369 1.68348 1.29289 1.29295C1.68342 0.902428 2.31658 0.902428 2.70711 1.29295L10.5 9.08588L15.7887 3.79717C15.7901 3.79576 15.7915 3.79435 15.7929 3.79295C15.7943 3.79155 15.7957 3.79016 15.7971 3.78877L17.8787 1.70718ZM16.5 5.91429L11.9142 10.5001L13.5 12.0859L18.0858 7.50007L16.5 5.91429ZM19.5 6.08586L17.9142 4.50007L19.2929 3.12139C19.6834 2.73086 20.3166 2.73086 20.7071 3.12138L20.8787 3.29296C21.2692 3.68348 21.2692 4.31664 20.8787 4.70717L19.5 6.08586ZM8.40716 12.593C8.79769 12.9835 8.79769 13.6167 8.40717 14.0072L4.88264 17.5317C4.24174 18.1727 3.7871 18.9757 3.56736 19.855L3.37492 20.6251L4.14493 20.4328C5.02441 20.213 5.8276 19.7584 6.4686 19.1174L9.99295 15.593C10.3835 15.2025 11.0166 15.2025 11.4072 15.593C11.7977 15.9835 11.7977 16.6167 11.4072 17.0072L7.88282 20.5316C6.98542 21.429 5.86095 22.0655 4.62968 22.3731L2.24317 22.9693C1.90243 23.0545 1.542 22.9546 1.29366 22.7062C1.04533 22.4579 0.94548 22.0974 1.03063 21.7567L1.62703 19.3702C1.93467 18.1391 2.57116 17.0148 3.46842 16.1175L6.99295 12.593C7.38347 12.2025 8.01664 12.2025 8.40716 12.593Z",
        fill: "currentColor"
    })
}), "PenSlash");
const _default = PenSlash;
